export enum VendorTypeResponse {
  MainBranch = 'mainbranch',
  Branch = 'branch'
}
